import { get } from 'framework/api/http';
import { useQuery } from 'react-query';

/* Get cc dashboard video list */
export const getCCTop10Videos = async ({ queryKey }: any) => {
  const { id } = queryKey[1];
  const res = await get(`/external-api/get_top10_videos/${id}`);
  return res?.data || [];
};

/* Use Query as a Hook */
export const useGetCCTop10Videos = (queryParams: any, onSuccess: any, onError: any) => {
  return useQuery(['cc-dashboard-top-10-videos', queryParams], getCCTop10Videos, {
    refetchOnWindowFocus: false,
    enabled: false,
    retry: 0,
    onSuccess,
    onError,
  });
};

export default useGetCCTop10Videos;
